import { Routes } from '@angular/router';
import { ServiceUnavailableComponent } from './shared/components/errors/service-unavailable/service-unavailable.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/auth-redirect/auth-redirect.module').then(mod => mod.AuthRedirectModule),
  },
  {
    path: 'mobile',
    loadChildren: () => import('./modules/mobile/mobile.module').then(mod => mod.MobileModule),
  },
  {
    path: 'desktop',
    loadChildren: () => import('./modules/desktop/desktop.module').then(mod => mod.DesktopModule),
  },
  {
    path: 'service-unavailable',
    component: ServiceUnavailableComponent,
  },
];
